
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key são obrigatórios');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos para o blog
export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  published_at: string;
  reading_time: number;
  image_url: string;
  is_published: boolean;
  views: number;
  helpful_count: number;
  created_at?: string;
  updated_at?: string;
}

export interface NewsletterSubscription {
  id: string;
  email: string;
  subscribed_at: string;
  is_active: boolean;
}

// Tipos para FAQ
export interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string;
  keywords: string[];
  order_position: number;
  is_published: boolean;
  views: number;
  helpful_count: number;
  created_at?: string;
  updated_at?: string;
}
